import { useEffect, useRef } from "react";
import gsap from "gsap";
import Spinner from "../../../shared/components/ui/Spinner";
import Button from "../../../shared/components/ui/Button";

export default function TrainingTab({ trainingStats, showRain }) {
  const cardsRef = useRef([]);
  const animDone = useRef(false);

  useEffect(() => {
    if (trainingStats && cardsRef.current.length && !animDone.current) {
      gsap.fromTo(
        cardsRef.current.filter(Boolean),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.4, stagger: 0.05, ease: "power2.out" }
      );
      animDone.current = true;
    }
  }, [trainingStats]);

  if (!trainingStats) {
    return (
      <div className="stats-loading-section">
        <Spinner size="md" />
        Loading training data...
      </div>
    );
  }

  return (
    <div className="training-stats-grid">
      {/* Summary cards */}
      <div className="stat-cards-grid">
        <div className="stat-card total" ref={(el) => (cardsRef.current[0] = el)}>
          <span className="stat-value">{trainingStats.total || 0}</span>
          <span className="stat-label">Total Images</span>
        </div>
        <div className="stat-card pending" ref={(el) => (cardsRef.current[1] = el)}>
          <span className="stat-value">{trainingStats.by_status?.pending || 0}</span>
          <span className="stat-label">Pending</span>
        </div>
        <div className="stat-card processing" ref={(el) => (cardsRef.current[2] = el)}>
          <span className="stat-value">{trainingStats.by_status?.processing || 0}</span>
          <span className="stat-label">Processing</span>
        </div>
        <div className="stat-card info" ref={(el) => (cardsRef.current[3] = el)}>
          <span className="stat-value">{trainingStats.by_status?.ready || 0}</span>
          <span className="stat-label">Ready for Labeling</span>
        </div>
        <div className="stat-card done" ref={(el) => (cardsRef.current[4] = el)}>
          <span className="stat-value">{trainingStats.by_status?.done || 0}</span>
          <span className="stat-label">Completed</span>
        </div>
        <div className="stat-card error" ref={(el) => (cardsRef.current[5] = el)}>
          <span className="stat-value">{trainingStats.by_status?.error || 0}</span>
          <span className="stat-label">Errors</span>
        </div>
      </div>

      {/* Face stats */}
      <div className="stats-subsection">
        <h3>Face Statistics</h3>
        <div className="stat-cards-grid">
          <div className="stat-card total">
            <span className="stat-value">{trainingStats.faces?.total || 0}</span>
            <span className="stat-label">Total Faces Detected</span>
          </div>
          <div className="stat-card done">
            <span className="stat-value">{trainingStats.faces?.labeled || 0}</span>
            <span className="stat-label">Labeled</span>
          </div>
          <div className="stat-card warning">
            <span className="stat-value">{trainingStats.faces?.unlabeled || 0}</span>
            <span className="stat-label">Unlabeled</span>
          </div>
          {trainingStats.faces?.total > 0 && (
            <div className="stat-card highlight">
              <span className="stat-value">
                {(
                  ((trainingStats.faces?.labeled || 0) / trainingStats.faces.total) *
                  100
                ).toFixed(1)}
                %
              </span>
              <span className="stat-label">Completion Rate</span>
            </div>
          )}
        </div>
      </div>

      {/* Quick actions */}
      <div className="stats-subsection">
        <h3>Quick Actions</h3>
        <Button
          variant="primary"
          onClick={() => (window.location.href = "/training")}
        >
          Go to Training Page
        </Button>
      </div>
    </div>
  );
}
